import { inject, injectWithTransform, singleton } from "tsyringe";
import { Logger, LoggerTransformer } from "./logger";
import { HttpClient } from "./http-client";
import { COOKIES } from "@identity/symbols";
import { Geo } from "./geo";

@singleton()
export class GeoCookie {
  constructor(
    @inject(COOKIES) private readonly cookiesManager: CookiesManager,
    @inject(HttpClient) private readonly httpClient: HttpClient,
    @injectWithTransform(Logger, LoggerTransformer, "GeoCookie")
    private readonly logger: Logger,
    @inject(Geo) private geo: Geo,
  ) {}

  async setGeoCookieIfNotExist(): Promise<void> {
    if (this.cookiesManager.get("Geo")) {
      this.logger.info("Geo cookie already exists");
      return;
    }
    const GEO_SERVICE_URL = "https://services.fandom.com/geoip/location";
    const response = await this.httpClient.get(GEO_SERVICE_URL);
    const { country_code, region, continent_code } = await response.json();
    const geoData = {
      country: country_code,
      region,
      continent: continent_code,
    };
    const geoCookie = JSON.stringify(geoData);

    this.cookiesManager.set("Geo", geoCookie, { expires: 365 });
    this.geo.set(geoData);

    this.logger.info("Geo cookie set");
  }
}
